/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Court_FreeInputs */

const th_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ว่าง`)
};

const en_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const ja_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空き`)
};

const zh_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空闲`)
};

const es_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libre`)
};

const pt_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livre`)
};

const id_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosong`)
};

const fr_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libre`)
};

const tl_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bakante`)
};

const vi_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trống`)
};

const ko_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비어 있음`)
};

const de_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frei`)
};

const ru_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свободна`)
};

const tr_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boş`)
};

const it_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libero`)
};

const pl_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wolne`)
};

const uk_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вільний`)
};

const hi_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली`)
};

const ar_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شاغر`)
};

const ms_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosong`)
};

const bn_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খালি`)
};

const zh_tw2_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空著`)
};

const zh_hk2_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空著`)
};

const ur_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خالی`)
};

const fa_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آزاد`)
};

const sw_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wazi`)
};

const nl_court_free = /** @type {(inputs: Court_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vrij`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Court_FreeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const court_free = /** @type {((inputs?: Court_FreeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Court_FreeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_court_free(inputs)
	if (locale === "ja") return ja_court_free(inputs)
	if (locale === "zh") return zh_court_free(inputs)
	if (locale === "es") return es_court_free(inputs)
	if (locale === "pt") return pt_court_free(inputs)
	if (locale === "id") return id_court_free(inputs)
	if (locale === "fr") return fr_court_free(inputs)
	if (locale === "tl") return tl_court_free(inputs)
	if (locale === "vi") return vi_court_free(inputs)
	if (locale === "ko") return ko_court_free(inputs)
	if (locale === "de") return de_court_free(inputs)
	if (locale === "ru") return ru_court_free(inputs)
	if (locale === "tr") return tr_court_free(inputs)
	if (locale === "it") return it_court_free(inputs)
	if (locale === "pl") return pl_court_free(inputs)
	if (locale === "uk") return uk_court_free(inputs)
	if (locale === "hi") return hi_court_free(inputs)
	if (locale === "ar") return ar_court_free(inputs)
	if (locale === "ms") return ms_court_free(inputs)
	if (locale === "bn") return bn_court_free(inputs)
	if (locale === "zh-TW") return zh_tw2_court_free(inputs)
	if (locale === "zh-HK") return zh_hk2_court_free(inputs)
	if (locale === "ur") return ur_court_free(inputs)
	if (locale === "fa") return fa_court_free(inputs)
	if (locale === "sw") return sw_court_free(inputs)
	if (locale === "nl") return nl_court_free(inputs)
	return en_court_free(inputs)
});